const locale = {
    monthsShort : {
        format: ["Urt.", "Ots.", "Mar.",  "Api.", "Mai.", "Eka.", "Uzt.", "Abu.", "Ira.", "Urr.", "Aza.", "Abe."],
        standalone: ["Urt.", "Ots.", "Mar.",  "Api.", "Mai.", "Eka.", "Uzt.", "Abu.", "Ira.", "Urr.", "Aza.", "Abe."]
    },
    weekdaysMin : ["Ig.", "Al.", "As.", "Az.", "Og.", "Or.", "Lr."]

};

export default locale;